"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _combineStreams = _interopRequireDefault(require("../util/combine-streams"));

var _constants = require("../util/constants");

var _apiKeys = _interopRequireDefault(require("./api-keys"));

var _collaborators = _interopRequireDefault(require("./collaborators"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Gateways = /*#__PURE__*/function () {
  function Gateways(api, _ref) {
    var defaultUserId = _ref.defaultUserId,
        stackConfig = _ref.stackConfig;
    (0, _classCallCheck2["default"])(this, Gateways);
    this._api = api;
    this._defaultUserId = defaultUserId;
    this._stackConfig = stackConfig;
    this.ApiKeys = new _apiKeys["default"](api.GatewayAccess, {
      parentRoutes: {
        get: 'gateway_ids.gateway_id',
        list: 'gateway_ids.gateway_id',
        create: 'gateway_ids.gateway_id',
        update: 'gateway_ids.gateway_id'
      }
    });
    this.Collaborators = new _collaborators["default"](api.GatewayAccess, {
      parentRoutes: {
        get: 'gateway_ids.gateway_id',
        list: 'gateway_ids.gateway_id',
        set: 'gateway_ids.gateway_id'
      }
    });
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(Gateways, [{
    key: "_emitDefaults",
    value: function _emitDefaults(paths, gateway) {
      // Handle zero coordinates that are swallowed by the grpc-gateway for
      // gateway antennas.
      if (paths.includes('antennas') && Boolean(gateway.antennas)) {
        var antennas = gateway.antennas;

        var _iterator = _createForOfIteratorHelper(antennas),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var antenna = _step.value;

            if (antenna !== null && (0, _typeof2["default"])(antenna) === 'object' && antenna.location !== null && (0, _typeof2["default"])(antenna.location) === 'object') {
              if (!('altitude' in antenna.location)) {
                antenna.location.altitude = 0;
              }

              if (!('longitude' in antenna.location)) {
                antenna.location.longitude = 0;
              }

              if (!('latitude' in antenna.location)) {
                antenna.location.latitude = 0;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } // Handle missing boolean values.


      if (paths.includes('location_public') && !Boolean(gateway.location_public)) {
        gateway.location_public = false;
      }

      if (paths.includes('status_public') && !Boolean(gateway.status_public)) {
        gateway.status_public = false;
      }

      if (paths.includes('auto_update') && !Boolean(gateway.auto_update)) {
        gateway.auto_update = false;
      }

      if (paths.includes('schedule_downlink_late') && !Boolean(gateway.schedule_downlink_late)) {
        gateway.schedule_downlink_late = false;
      }

      if (paths.includes('require_authenticated_connection') && !Boolean(gateway.require_authenticated_connection)) {
        gateway.require_authenticated_connection = false;
      }

      if (paths.includes('update_location_from_status') && !Boolean(gateway.update_location_from_status)) {
        gateway.update_location_from_status = false;
      }

      if (paths.includes('disable_packet_broker_forwarding') && !Boolean(gateway.disable_packet_broker_forwarding)) {
        gateway.disable_packet_broker_forwarding = false;
      }

      return gateway;
    } // Retrieval.

  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.GatewayRegistry.List(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context.sent;
                return _context.abrupt("return", _marshaler["default"].unwrapGateways(response));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, selector) {
        var fieldMask, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.GatewayRegistry.Get({
                  routeParams: {
                    'gateway_ids.gateway_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", this._emitDefaults(fieldMask.field_mask.paths, _marshaler["default"].unwrapGateway(response)));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getById(_x3, _x4) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.EntityRegistrySearch.SearchGateways(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].unwrapGateways(response));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function search(_x5, _x6) {
        return _search.apply(this, arguments);
      }

      return search;
    }() // Update.

  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(id, patch) {
        var mask,
            response,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                mask = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : _marshaler["default"].fieldMaskFromPatch(patch, this._api.GatewayRegistry.UpdateAllowedFieldMaskPaths);

                // Apply exceptional field mask requirement for `lbs_lns_secret.value`.
                if (mask.includes('lbs_lns_secret.value')) {
                  mask.push('lbs_lns_secret');
                }

                _context4.next = 4;
                return this._api.GatewayRegistry.Update({
                  routeParams: {
                    'gateway.ids.gateway_id': id
                  }
                }, {
                  gateway: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 4:
                response = _context4.sent;
                return _context4.abrupt("return", this._emitDefaults(mask, _marshaler["default"].unwrapGateway(response)));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateById(_x7, _x8) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }()
  }, {
    key: "restoreById",
    value: function () {
      var _restoreById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(id) {
        var response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.GatewayRegistry.Restore({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function restoreById(_x9) {
        return _restoreById.apply(this, arguments);
      }

      return restoreById;
    }() // Creation.

  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var ownerId,
            gateway,
            isUserOwner,
            routeParams,
            response,
            _args6 = arguments;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                ownerId = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : this._defaultUserId;
                gateway = _args6.length > 1 ? _args6[1] : undefined;
                isUserOwner = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : true;
                routeParams = isUserOwner ? {
                  'collaborator.user_ids.user_id': ownerId
                } : {
                  'collaborator.organization_ids.organization_id': ownerId
                };
                _context6.next = 6;
                return this._api.GatewayRegistry.Create({
                  routeParams: routeParams
                }, {
                  gateway: gateway
                });

              case 6:
                response = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].unwrapGateway(response));

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Deletion.

  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(id) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.GatewayRegistry.Delete({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteById(_x10) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(id) {
        var response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.GatewayRegistry.Purge({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function purgeById(_x11) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }() // Miscellaneous.

  }, {
    key: "getStatisticsById",
    value: function () {
      var _getStatisticsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(id) {
        var response;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.Gs.GetGatewayConnectionStats({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getStatisticsById(_x12) {
        return _getStatisticsById.apply(this, arguments);
      }

      return getStatisticsById;
    }()
  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(gatewayId) {
        var result;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this._api.GatewayAccess.ListRights({
                  routeParams: {
                    gateway_id: gatewayId
                  }
                });

              case 2:
                result = _context10.sent;
                return _context10.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getRightsById(_x13) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }() // Events Stream

  }, {
    key: "openStream",
    value: function () {
      var _openStream = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(identifiers, names, tail, after) {
        var _this = this;

        var payload, distinctComponents, streams;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                payload = {
                  identifiers: identifiers.map(function (id) {
                    return {
                      gateway_ids: {
                        gateway_id: id
                      }
                    };
                  }),
                  names: names,
                  tail: tail,
                  after: after
                }; // Event streams can come from multiple stack components. It is necessary to
                // check for stack components on different hosts and open distinct stream
                // connections for any distinct host if need be.

                distinctComponents = this._stackConfig.getComponentsWithDistinctBaseUrls([_constants.STACK_COMPONENTS_MAP.is, _constants.STACK_COMPONENTS_MAP.gs]);
                streams = distinctComponents.map(function (component) {
                  return _this._api.Events.Stream({
                    component: component
                  }, payload);
                }); // Combine all stream sources to one subscription generator.

                return _context11.abrupt("return", (0, _combineStreams["default"])(streams));

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function openStream(_x14, _x15, _x16, _x17) {
        return _openStream.apply(this, arguments);
      }

      return openStream;
    }() // Gateway Configuration Server.

  }, {
    key: "getGlobalConf",
    value: function () {
      var _getGlobalConf = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(gatewayId) {
        var endpoint, response;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                // Endpoint hardcoded because it is not part of the gRPC API.
                // Refactor implementation once the following issue is resolved:
                // https://github.com/TheThingsNetwork/lorawan-stack/issues/3280
                endpoint = "/gcs/gateways/".concat(gatewayId, "/semtechudp/global_conf.json");
                _context12.next = 3;
                return this._api._connector.handleRequest('get', endpoint, 'gcs', false);

              case 3:
                response = _context12.sent;
                return _context12.abrupt("return", _marshaler["default"].payloadSingleResponse(response.data));

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getGlobalConf(_x18) {
        return _getGlobalConf.apply(this, arguments);
      }

      return getGlobalConf;
    }()
  }]);
  return Gateways;
}();

var _default = Gateways;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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